import {createI18nScope, ref} from 'common/i18n/scope';
import {withComment} from 'common/i18n/util';
import mixpanelSettingsScope from 'common/mixpanel-settings/index.i18n';

export default createI18nScope(`common.report.util.saved-entities`, {
  'common.cancel': `Cancel`,
  'components.create-entity.create': `Create New`,
  'components.create-entity.edit': `Edit`,
  'components.sharing.owner-filter.all': `Created By Anyone`,
  'components.sharing.owner-filter.not-yours': `Not Created By You`,
  'components.sharing.owner-filter.shared': `Shared With You`,
  'components.sharing.owner-filter.yours': `Created By You`,
  'mixology.agent-flow': `Automation`,
  'mixology.agent-flow_plural': `Automations`,
  'mixology.behavior': `Behavior`,
  'mixology.behavior_plural': `Behaviors`,
  'mixology.board': withComment(`short for "Dashboard"`, `Board`),
  'mixology.board_plural': withComment(`short for "Dashboards"`, `Boards`),
  'mixology.cohort': `Cohort`,
  'mixology.cohort_plural': `Cohorts`,
  'mixology.custom-event': `Custom Event`,
  'mixology.custom-event-property': `Custom Event Property`,
  'mixology.custom-event_plural': `Custom Events`,
  'mixology.custom-profile-property': `Custom Profile Property`,
  'mixology.custom-property': `Custom Property`,
  'mixology.custom-property_plural': `Custom Properties`,
  'mixology.data-group': `Data Group`,
  'mixology.data-group_plural': `Data Groups`,
  'mixology.data-point': `Data Point`,
  'mixology.data-point_plural': `Data Points`,
  'mixology.data-view': `Data View`,
  'mixology.data-view_plural': `Data Views`,
  'mixology.editor': `Editor`,
  'mixology.event': `Event`,
  'mixology.event-property': `Event Property`,
  'mixology.event-property_plural': `Event Properties`,
  'mixology.event_plural': `Events`,
  'mixology.experiment': `Experiment`,
  'mixology.experiment_plural': `Experiments`,
  'mixology.feature-flag': `Feature Flag`,
  'mixology.feature-flag_plural': `Feature Flags`,
  'mixology.formula': `Formula`,
  'mixology.funnel': `Funnel`,
  'mixology.heat-map': `Heatmap`,
  'mixology.heat-map-collection': `Heatmap Collection`,
  'mixology.journey': `Journey`,
  'mixology.journey_plural': `Journeys`,
  'mixology.lookup-table': `Lookup Table`,
  'mixology.lookup-table_plural': `Lookup Tables`,
  'mixology.metric': `Metric`,
  'mixology.metric-tree': `Metric Tree`,
  'mixology.metric-tree_plural': `Metric Trees`,
  'mixology.metric_plural': `Metrics`,
  'mixology.playlist': `Playlist`,
  'mixology.private-data-view': `Private Data View`,
  'mixology.profile': `Profile`,
  'mixology.profile-property': `Profile Property`,
  'mixology.profile-property_plural': `Profile Properties`,
  'mixology.profile_plural': `Profiles`,
  'mixology.property': `Property`,
  'mixology.property_plural': `Properties`,
  'mixology.report': `Report`,
  'mixology.report-count_one': `1 $t(mixology.report)`,
  'mixology.report-count_other': `{{count}} $t(mixology.report_plural)`,
  'mixology.report_plural': `Reports`,
  'mixology.user-access.creator': ref(mixpanelSettingsScope, `mixology.user-access.creator`),
  'mixology.user-access.editor': ref(mixpanelSettingsScope, `mixology.user-access.editor`),
  'mixology.user-access.none': ref(mixpanelSettingsScope, `mixology.user-access.none`),
  'mixology.user-access.viewer': ref(mixpanelSettingsScope, `mixology.user-access.viewer`),
  'mixology.user-role.admin': ref(mixpanelSettingsScope, `mixology.user-role.admin`),
  'mixology.user-role.analyst': ref(mixpanelSettingsScope, `mixology.user-role.analyst`),
  'mixology.user-role.billing-admin': ref(mixpanelSettingsScope, `mixology.user-role.billing-admin`),
  'mixology.user-role.consumer': ref(mixpanelSettingsScope, `mixology.user-role.consumer`),
  'mixology.user-role.member': ref(mixpanelSettingsScope, `mixology.user-role.member`),
  'mixology.user-role.messenger': ref(mixpanelSettingsScope, `mixology.user-role.messenger`),
  'mixology.user-role.owner': ref(mixpanelSettingsScope, `mixology.user-role.owner`),
  'mixology.verified': `Verified`,
  'mixology.workspace': ref(mixpanelSettingsScope, `mixology.workspace`),
  'mixology.workspace_plural': ref(mixpanelSettingsScope, `mixology.workspace_plural`),
  'reports.superadmin-override.bulk-no-edit-access-owner': `You have not been given edit access to the following {{entityCount}} {{entityTypeName}}:\n\n{{entityNames}}\n\nAs a project Owner you can override this setting. Would you like to continue?`,
  'reports.superadmin-override.bulk-no-edit-access-staff': `You have not been given edit access to the following {{entityCount}} {{entityTypeName}}:\n\n{{entityNames}}\n\nAs a staff user you can override this setting. Would you like to continue?`,
  'reports.superadmin-override.bulk-partial-no-edit-access-owner': `You have not been given edit access to the following {{entityCount}} out of {{totalCount}} {{entityTypeName}}:\n\n{{entityNames}}\n\nAs a project Owner you can override this setting. Would you like to continue?`,
  'reports.superadmin-override.bulk-partial-no-edit-access-staff': `You have not been given edit access to the following {{entityCount}} out of {{totalCount}} {{entityTypeName}}:\n\n{{entityNames}}\n\nAs a staff user you can override this setting. Would you like to continue?`,
  'reports.superadmin-override.confirm-add': `Yes, Add`,
  'reports.superadmin-override.confirm-add-all': `Yes, Add to All`,
  'reports.superadmin-override.confirm-continue': `Yes, Continue`,
  'reports.superadmin-override.confirm-share': `Yes, Share`,
  'reports.superadmin-override.make-a-copy': `No, Make a Copy`,
  'reports.superadmin-override.no-edit-access-owner': `The creator of this {{entityTypeName}} has not given you edit access.\n\nAs a project Owner you can override this setting. Would you like to continue?`,
  'reports.superadmin-override.no-edit-access-staff': `The creator of this {{entityTypeName}} has not given you edit access.\n\nAs a staff user you can override this setting. Would you like to continue?`,
  'reports.superadmin-override.no-share-access-owner': `The creator of this {{entityTypeName}} has not given you edit access to share.\n\nAs a project Owner you can override this setting. Would you like to continue?`,
  'reports.superadmin-override.no-share-access-staff': `The creator of this {{entityTypeName}} has not given you edit access to share.\n\nAs a staff user you can override this setting. Would you like to continue?`,
  'reports.superadmin-override.title': `You Don't Have Access`,
  'settings.user-role.org-description.admin': `Access and administrative controls of the organization and its projects. Admins cannot delete projects nor edit billing information`,
  'settings.user-role.org-description.analyst': `Access to all projects in the organization as an Analyst`,
  'settings.user-role.org-description.billing-admin': `View and manage billing for an organization`,
  'settings.user-role.org-description.consumer': `Access to all projects in the organization as a Consumer`,
  'settings.user-role.org-description.member': `No special permissions tied to the organization`,
  'settings.user-role.org-description.messenger': `Access to all projects in the organization as a Messenger`,
  'settings.user-role.org-description.owner': `Full access to everything in the organization including all projects`,
  'settings.user-role.project-description.admin': `Administrative controls, but no project deletion privileges`,
  'settings.user-role.project-description.analyst': `View, save, and share reports`,
  'settings.user-role.project-description.billing-admin': `This role does nothing at the project level`,
  'settings.user-role.project-description.consumer': `View and create unlisted reports`,
  'settings.user-role.project-description.messenger': `View and save reports and access messages`,
  'settings.user-role.project-description.owner': `Full access to everything`,
});
